import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  EntitlementResolution,
  FeatureEntitlement,
  PropsEntitlementsState,
} from './interfaces';

const initialState: PropsEntitlementsState = {
  resolution: null,
  loading: false,
  error: null,
};

const entitlementsSlice = createSlice({
  name: 'entitlements',
  initialState,
  reducers: {
    entitlementsRequest(state) {
      state.loading = true;
      state.error = null;
    },
    entitlementsSetResolution(state, action: PayloadAction<EntitlementResolution>) {
      state.resolution = action.payload;
      state.loading = false;
      state.error = null;
    },
    entitlementsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    entitlementsConsumeQuota(
      state,
      action: PayloadAction<{ feature: string; remaining: number | null; used: number }>,
    ) {
      if (!state.resolution) return;
      const current = state.resolution.features[action.payload.feature];
      if (!current) return;
      const next: FeatureEntitlement = {
        ...current,
        quotaUsed: action.payload.used,
        quotaRemaining: action.payload.remaining,
      };
      state.resolution.features[action.payload.feature] = next;
    },
    clearEntitlements: () => initialState,
  },
});

export const {
  entitlementsRequest,
  entitlementsSetResolution,
  entitlementsFailure,
  entitlementsConsumeQuota,
  clearEntitlements,
} = entitlementsSlice.actions;
export default entitlementsSlice.reducer;
